// Timing logs for uploads and previews, in development builds only.
export const now = () => (typeof performance !== "undefined" ? performance.now() : Date.now());

// Milliseconds rounded for reading.
export const ms = (value) => Math.round(value * 10) / 10;

// Logs how long `label` took since `start`, with any details.
export const logTimings = (label, start, details = {}) => {
  if (process.env.NODE_ENV !== "development") return;
  // eslint-disable-next-line no-console
  console.debug(`[timing] ${label}: ${ms(now() - start)} ms`, details);
};
